import { useMemo } from 'react';
import type { IconName } from '@frontend/icons';

export type NavLink = {
  disabled?: boolean;
  hide?: boolean;
  iconName?: IconName;
  label: string;
  to?: string;
  subnav?: NavLink[];
  trackingId?: string;
};

export const useMainNavItems = () => {
  const mainNavItems: NavLink[] = useMemo(
    () => [
      {
        label: 'Dashboard',
        to: '/dashboard',
      },
      { label: 'Feature Flags', to: '/feature-flags' },
      {
        label: 'Phones',
        subnav: [
          { label: 'Call Settings', to: '/phone/call-settings' },
          { label: 'Devices', to: '/phone/devices' },
          { label: 'Fax Settings', to: '/phone/fax-settings' },
          { label: 'Media Library', to: '/phone/media-library' },
          { label: 'Office Hours', to: '/phone/office-hours' },
          { label: 'Phone Tree', to: '/phone/phone-tree' },
          { label: 'Order New Number', to: '/phone/order-new-number' },
          { label: 'Voice Mailboxes', to: '/phone/voicemail-boxes' },
        ],
      },
      {
        label: 'History',
        subnav: [
          { label: 'Appointments', to: '/history/appointments' },
          { label: 'Call Records', to: '/history/call-records' },
          { label: 'Client Locations', to: '/history/client-locations' },
          { label: 'Email', to: '/history/email' },
          { label: 'Logs', to: '/history/logs' },
          { label: 'Order Events', to: '/history/order-events' },
          { label: 'Patient', to: '/history/patient' },
          { label: 'Recall Events', to: '/history/recall-events' },
          { label: 'SMS', to: '/history/sms' },
          { label: 'Writebacks', to: '/history/writebacks' },
          { label: 'Audit Logs', to: '/dashboard/audit-logs' },
        ],
      },
      {
        label: 'Settings',
        subnav: [
          { label: '10DLC', to: '/settings/10-dlc' },
          { label: 'Email Marketing', to: '/settings/email-marketing' },
          { label: 'Feature Flags', to: '/settings/feature-flags' }, // TODO: should we make this more generic 'flags'
          { label: 'Locations', to: '/settings/locations' },
          { label: 'Manual Templates', to: '/settings/manual-templates' },
          { label: 'Online Scheduling', to: '/settings/online-scheduling' },
          { label: 'Payments', to: '/settings/payments' },
          { label: 'Billing', to: '/settings/billing' },
          { label: 'Reviews', to: '/settings/reviews' },
          { label: 'Users', to: '/settings/users' },
          { label: 'Desktop Clients', to: '/settings/desktop-clients' },
        ],
      },
      {
        label: 'SyncApp',
        subnav: [
          { label: 'SyncApp', to: '/sync-app/' },
          { label: 'MultiLocation Settings', to: '/sync-app/multi-location' },
        ],
      },
      {
        label: 'Onboarding',
        subnav: [
          { label: 'Handoff Hub', to: '/onboarding/handoff-hub' },
          { label: 'Onboarding', to: '/onboarding/onboarding' },
          { label: 'Intake Form', to: '/onboarding/intake-form' },
          { label: 'Porting', to: '/onboarding/porting' },
        ],
      },
    ],
    []
  );

  return mainNavItems;
};

export const useGlobalNavItems = () => {
  const globalNavItems: NavLink[] = [
    {
      iconName: 'network-small',
      label: 'Global Settings',
      subnav: [
        { label: 'User Config', to: '/global-settings/user-config' },
        { label: 'Global Feature Flags', to: '/global-settings/feature-flags' },
        { label: 'E911 Dashboard', to: '/global-settings/global-settings' },
        { label: 'Portability Check', to: '/global-settings/portability-check' },
        { label: 'Desktop Releases', to: '/global-settings/desktop-releases' },
        { label: 'Releases', to: '/global-settings/releases' },
        { label: 'Global Audit Logs', to: '/global-settings/global-audit-logs' },
        { label: 'Outage Alerts', to: '/global-settings/outage-alerts' },
        { label: 'User Look Up', to: '/global-settings/user-look-up' },
        { label: 'Provision Locations', to: '/global-settings/provision-locations' },
        { label: 'Truelark Configurations', to: '/global-settings/truelark-configurations' },
      ],
    },
  ];
  return globalNavItems;
};
